// YYYY-MM-DD Thh:mm:ssをYYYY.MM.DD へ変換
const changeDateFormat = (date) => {
    if (date !== undefined) {
        var slicedDate = date.substr(0,10)
        var changedDate = slicedDate.replaceAll('-', '.')
        return changedDate
    }
    return ''
}

export default changeDateFormat